export default "__VITE_ASSET__CwhwR9a4__"